import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Big Strides Inc</h3>
            <p>Your Strategic Procurement Partner</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/oem-and-channels">OEM & Channel Partners</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li>
                <a href="mailto:info@bigstridesinc.com">
                  info@bigstridesinc.com
                </a>
              </li>
              <li>
                <a href="tel:+14039262032">+1 (403) 926-2032</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Big Strides Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

